import { __assign, __awaiter, __generator } from "tslib";
import { getVisibleSymbolsInLayout } from 'shared/utils/ad';
import debug from 'shared/utils/debug';
/**
 * Specify the plugin file need to be loaded in production code
 */
var pluginLoaders = {
    video: function () { return import(/* webpackChunkName: "video" */ './videoManager'); },
    carousel: function () {
        return import(/* webpackChunkName: "carousel" */ './carouselManager');
    },
};
/**
 * Load plugin based on symbol type
 * Promise to return only the symbol types that have the url loaded
 */
var loadPluginsBySymbolTypes = function (ad, layoutId, isProof) { return __awaiter(void 0, void 0, void 0, function () {
    var loaders, loaderInstances;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loaders = getVisibleSymbolsInLayout(ad, layoutId)
                    .map(function (sym) { return sym.type; })
                    // only type that has plugin url
                    .filter(function (type) { return pluginLoaders[type]; })
                    // unique
                    .filter(function (val, idx, self) { return self.indexOf(val) === idx; })
                    .map(function (symbolType) { return __awaiter(void 0, void 0, void 0, function () {
                    var loader, loadedModule, pluginConstructor, instance;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                debug("Loading support file for plugin: " + symbolType + ".");
                                loader = pluginLoaders[symbolType];
                                return [4 /*yield*/, loader()];
                            case 1:
                                loadedModule = _b.sent();
                                pluginConstructor = 'default' in loadedModule ? loadedModule.default : loadedModule;
                                instance = new pluginConstructor();
                                instance.setup(ad, layoutId, isProof);
                                return [2 /*return*/, (_a = {}, _a[symbolType] = instance, _a)];
                        }
                    });
                }); });
                return [4 /*yield*/, Promise.all(loaders)];
            case 1:
                loaderInstances = _a.sent();
                return [2 /*return*/, loaderInstances.reduce(function (acc, record) { return (__assign(__assign({}, acc), record)); }, {})];
        }
    });
}); };
export default loadPluginsBySymbolTypes;
